import React, { useEffect, useState } from 'react';

import { Pagination } from 'antd';
import Header from './header'


import style from '../scss/business.scss'

function Business(props){

    const PaginChange=(page,pageSize)=>{
        
    }



    return (
        <>
                      <Header></Header>

            <div className="box9">
                 <div className="box9-logo"></div>
            </div>
 

            <div className="box10">
                <div className="title">
                    <h1>哪些大牌选择了我们</h1>
                    <span></span> 
                </div>

                <div className="brand-list">
                <img src={require('../imgs/icon4/01.png')} alt="" />
                <img src={require('../imgs/icon4/02.png')} alt="" />
                <img src={require('../imgs/icon4/03.png')} alt="" />
                <img src={require('../imgs/icon4/04.png')} alt="" />
                <img src={require('../imgs/icon4/05.png')} alt="" />
                <img src={require('../imgs/icon4/06.png')} alt="" />
                </div>
            </div>


            <div className="box11">
                <div className="title">
                    <h1>精选案例</h1>
                    <span></span> 
                </div>

                <section>
                    <img src={require('../imgs/icon5/01.png')} alt="" />
                    <img src={require('../imgs/icon5/02.png')} alt="" />
                    <img src={require('../imgs/icon5/03.png')} alt="" />
                    <img src={require('../imgs/icon5/04.png')} alt="" />
                </section>   
            </div>

            <div className="box12">
                <div className="title">
                    <h1>全部案例</h1>
                    <span></span> 
                </div>

                <div className="fenye">
                    <img src={require('../imgs/icon6/001.png')} alt="" />
                    <img src={require('../imgs/icon6/002.png')} alt="" />
                    <img src={require('../imgs/icon6/003.png')} alt="" />
                    <img src={require('../imgs/icon6/004.png')} alt="" />
                    <img src={require('../imgs/icon6/005.png')} alt="" />
                    <img src={require('../imgs/icon6/006.png')} alt="" />
                    <img src={require('../imgs/icon6/007.png')} alt="" />
                    <img src={require('../imgs/icon6/008.png')} alt="" />
                    <img src={require('../imgs/icon6/001.png')} alt="" />
                    <img src={require('../imgs/icon6/002.png')} alt="" />
                    <img src={require('../imgs/icon6/003.png')} alt="" />
                    <img src={require('../imgs/icon6/004.png')} alt="" />
                    <img src={require('../imgs/icon6/005.png')} alt="" />
                    <img src={require('../imgs/icon6/006.png')} alt="" />
                    <img src={require('../imgs/icon6/007.png')} alt="" />
                    <img src={require('../imgs/icon6/008.png')} alt="" />
                </div>
 
                <Pagination defaultCurrent={1} total={16} defaultPageSize={16} onChange={PaginChange} />

            </div>


            <div className="box13"></div>
            
            <div className="box14">
                <div className="box14s"></div>
            </div>

            <div className="box15">
            </div>


        </>
    )

}


export default Business